import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { api } from "../../lib/api";
import { Timeline } from "../../components/series/Timeline";
import { Cover } from "../Showcase";

export function PublicSeriesTimelines({ only, current }) {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/public/series").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  const shown = only ? list.filter((s) => s.id === only && s.books.length + (s.box_sets?.length || 0) > 1) : list;
  if (!shown.length) return null;
  return (
    <section className={only ? "" : "max-w-6xl mx-auto px-4 sm:px-8 pb-16"} data-testid="public-series-section">
      {!only && <><p className="eyebrow mb-3">Where to start</p><h2 className="font-display text-3xl mb-10">Series reading order</h2></>}
      <div className="space-y-12">
        {shown.map((s) => (
          <div key={s.id} className="panel p-5 sm:p-7" data-testid={`public-series-${s.id}`}>
            <h3 className="font-display text-2xl">{s.name}</h3>
            {s.description && <p className="text-sm text-slate-400 mt-1 max-w-2xl">{s.description}</p>}
            <div className="mt-6"><Timeline data={s} cover={(b, small) => (small && !b.has_cover ? <div className="w-full h-full flex items-center justify-center bg-gradient-to-b from-amber-900/60 to-slate-950 border border-amber-500/30"><BookOpen size={14} className="text-amber-300" /></div> : <Cover b={b} className="w-full h-full" />)} linkFor={(b) => `/authors/${b.slug}`} Wrap={Link} currentId={current} testId={`public-timeline-${s.id}`} /></div>
          </div>
        ))}
      </div>
    </section>
  );
}
